module.exports = "<div *ngIf=\"displayError\" >\n  <span class=\"fa fa-times-circle form-control-feedback error-icon\"></span>\n  <span class=\"sr-only\">(error)</span>\n  <div class=\"error-msg\">\n    {{ errorMsg }}\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/alert-message/alert.component.html
// module id = ./src/app/shared/alert-message/alert.component.html
// module chunks = main